"use strict";
/**
 * Created on 02 06 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * <p>Serialization/deserialization of {@link PromotionProduct}.</p>
 *
 * @author JMe
 */


var PromotionProductConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PromotionProductConverter, _DataObjectConverter_);

  function PromotionProductConverter() {
    _classCallCheck(this, PromotionProductConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionProductConverter).apply(this, arguments));
  }

  return PromotionProductConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PromotionProductConverter = PromotionProductConverter;